<template>

    <div class="layout">
        <div class="leftPlan">
            <div class="leftBar">
                <ul>
                    <li><img src="@/assets/img/educationalAdministration/version1.png" class="img"/></li>
                    <li><img src="@/assets/img/educationalAdministration/version2.png" class="img"/></li>
                    <li><img src="@/assets/img/educationalAdministration/version3.png" class="img"/></li>
                </ul>
            </div>
        </div>
        <div class="rightPlan" v-loading="loading">
            <div class="totalPlan">
                <div class="card left-flex">
                    <div class="firstLine">
                        <el-button class="title" @click="createLogicalFrame('logic','')"
                                   :disabled="!powers.includes(132)">逻辑框
                        </el-button>
                        <el-button class="title" @click="createLogicalFrame('logicalDetail','标题')"
                                   :disabled="!powers.includes(132)">标题
                        </el-button>
                        <el-button class="title" @click="createLogicalFrame('logicalDetail','二级标题')"
                                   :disabled="!powers.includes(132)">二级标题
                        </el-button>
                        <el-button class="title" @click="createLogicalFrame('logicalDetail','三级标题')"
                                   :disabled="!powers.includes(132)">三级标题
                        </el-button>
                    </div>
                    <div class="secondLine">
                        <el-button class="title" @click="createLogicalFrame('logicalDetail','题干')"
                                   :disabled="!powers.includes(132)">题干
                        </el-button>
                        <el-button class="title" @click="createLogicalFrame('logicalDetail','图片')"
                                   :disabled="!powers.includes(132)">图片
                        </el-button>
                        <el-button class="title" @click="createLogicalFrame('logicalDetail','答案')"
                                   :disabled="!powers.includes(132)">答案
                        </el-button>
                        <el-button class="title" @click="createLogicalFrame('logicalDetail','批注')"
                                   :disabled="!powers.includes(132)">批注
                        </el-button>
                        <el-button class="title" @click="createLogicalFrame('logicalDetail','知识点')"
                                   :disabled="!powers.includes(132)">知识点
                        </el-button>
                    </div>
                    <vue-scroll :ops="$ops">
                        <div class="planItem" v-if="lessonPlan" style="margin-top:20px">
                            <div :key="logicItem.id" v-for="logicItem in orderLessonPlan" class="card logic-item-style"
                                 @click="chooseLogic(logicItem.id,'logicItem')"
                                 draggable="true"
                                 @dragover='allowDropLogic($event)'
                                 v-on:mousedown="handleMousedown(logicItem.id,$event)">
                                <div class="deleteDetail" @click="deleteLogic(logicItem.id,'logicItem')"
                                     v-if="logicItem.id===chooseLogic_id && powers.includes(132)">X
                                </div>
                                <div class="el-icon-caret-top upLogic" @click="sortLogic(logicItem.id,'up')"
                                     v-if="logicItem.id===chooseLogic_id && powers.includes(132)">
                                </div>
                                <div class="el-icon-caret-bottom downLogic" @click="sortLogic(logicItem.id,'down')"
                                     v-if="logicItem.id===chooseLogic_id && powers.includes(132)">
                                </div>
                                <div :key="logicDetail.id" v-for="logicDetail in logicItem.module_details" class="card logic-detail-style"
                                     @click="chooseLogic(logicDetail.id,'logicDetail')"
                                     :class="{'ueditor-active':logicDetail.id===chooseLogicDetail_id}">

                                    <div class="deleteDetail" @click="deleteLogic(logicDetail.id,'logicDetail')"
                                         v-if="logicDetail.id===chooseLogicDetail_id && powers.includes(132)">X
                                    </div>

                                    <QuillMath v-model="logicDetail.content"  v-if="logicDetail.id===chooseLogicDetail_id && powers.includes(132)"></QuillMath>
                                    <div v-html="logicDetail.content" v-else></div>

                                </div>
                            </div>
                        </div>
                    </vue-scroll>
                    <div class="card-footer text-right" v-if="powers.includes(132)">
                        <el-button type="primary" @click="handleAllSave()">保 存</el-button>
                        <el-button type="primary" @click="handlePrintPlan()">打 印</el-button>
                    </div>
                </div>
                <div class="card right-flex" @drop='drop($event)' @dragover='allowDropLogic($event)'>
                    <vue-scroll :ops="$ops">
                        <div class="teacherPlanItem" v-if="teacherLessonPlan" style="margin-top:20px">
                            <div :key="logicItem.id" v-for="logicItem in orderTeacherLessonPlan"
                                 class="card teacher-logic-item-style"
                                 @click="chooseTeacherLogic(logicItem.id,'logicItem')">
                                <div class="teacher-deleteDetail" @click="deleteTeacherLogic(logicItem.id,'logicItem')"
                                     v-if="logicItem.id===teacherChooseLogic_id && powers.includes(133)">X
                                </div>
                                <div class="el-icon-caret-top teacher-upLogic"
                                     @click="teacherSortLogic(logicItem.id,'up')"
                                     v-if="logicItem.id===teacherChooseLogic_id && powers.includes(133)">
                                </div>
                                <div class="el-icon-caret-bottom teacher-downLogic"
                                     @click="teacherSortLogic(logicItem.id,'down')"
                                     v-if="logicItem.id===teacherChooseLogic_id && powers.includes(133)">
                                </div>
                                <div :key="logicDetail.id" v-for="logicDetail in logicItem.teacherModuleDetails"
                                     class="card teacher-logic-detail-style"
                                     :class="{'ueditor-active':logicDetail.id===teacherChooseLogicDetail_id}"
                                     @click="chooseTeacherLogic(logicDetail.id,'logicDetail')">
                                    <div class="teacher-deleteDetail"
                                         @click="deleteTeacherLogic(logicDetail.id,'logicDetail')"
                                         v-if="logicDetail.id===teacherChooseLogicDetail_id && powers.includes(133)">X
                                    </div>
                                    <div  v-if="logicDetail.module_detail"
                                          v-html="logicDetail.module_detail.content">
                                        {{logicDetail.module_detail.content}}
                                    </div>
                                    <div class="ueditor-unactive" v-if="logicDetail.id!==teacherChooseLogicDetail_id">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vue-scroll>
                    <div class="card-footer text-right" v-if="powers.includes(133)">
                        <el-button type="primary" @click="handleTeacherAllSave()">保 存</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store'
    import QuillMath from  './Quill/QuillMath'

    export default {
        name: "TeacherPlan",
        data() {
            return {
                lessonPlan: '',
                teacherLessonPlan: '',
                total: 2,
                chooseLogic_id: '',
                chooseLogicDetail_id: '',
                loading: false,
                classPlan_id: '',
                dropLogicItem_id: '',
                teacherChooseLogic_id: '',
                teacherChooseLogicDetail_id: '',

            };
        },
        created() {
            this.handleLogicalFrame();
        },
        components: {
            "QuillMath":QuillMath
        },
        computed: {

            powers(){
                return this.$store.state.config.powers;
            },
            orderLessonPlan: function () {
                return this._.orderBy(this.lessonPlan.lessonPlanModules, 'sortBy','asc');
            },
            orderTeacherLessonPlan: function () {
                return this._.orderBy(this.teacherLessonPlan.teacherLessonPlanModules, 'sortBy','asc');
            }
        },
        destroyed() {
            if(this.lessonPlan){
                this.$Echo.leave('lessonPlan.' + this.lessonPlan.id);
            }
            if(this.teacherLessonPlan){
                this.$Echo.leave('teacherLessonPlan.' + this.teacherLessonPlan.id);
            }
        },
        methods: {
            handlePrintPlan(){
               // this.$Win.openModal('/print/standardPlan/' + this.classPlan_id , 760, 800, '标准教案');
            },
            handleEcho(){
                if(this.lessonPlan){
                    this.$Echo.private('lessonPlan.' + this.lessonPlan.id)
                        .listen('.lessonPlanDestroy', (e) => {
                            if(e.type==='logicItem'){
                                this.$delete(this.lessonPlan.lessonPlanModules, e.lessonPlanModule_id)
                            }else if(e.type==='logicDetail'){
                                for(let i in this.lessonPlan.lessonPlanModules[e.lessonPlanModule_id].module_details){
                                    if(this.lessonPlan.lessonPlanModules[e.lessonPlanModule_id].module_details[i].id===parseInt(e.moduleDetail_id)){
                                        this.lessonPlan.lessonPlanModules[e.lessonPlanModule_id].module_details.splice(i, 1)
                                    }
                                }
                            }
                        })
                        .listen('.lessonPlanModuleStore', (e) => {
                            this.$set(this.lessonPlan.lessonPlanModules, e.lessonPlanModule.id, e.lessonPlanModule);
                        })
                        .listen('.lessonPlanStore', (e) => {
                            this.lessonPlan=e.lessonPlan;
                        })
                        .listen('.moduleDetailStore', (e) => {
                            this.lessonPlan.lessonPlanModules[e.lessonPlanModule_id].module_details.push(e.moduleDetail)
                        })
                        .listen('.lessonPlanSortBy', (e) => {
                            this.lessonPlan.lessonPlanModules[e.lessonPlanModule_id].sortBy=e.sortBy;
                        });
                }
                if(this.teacherLessonPlan){
                    this.$Echo.private('teacherLessonPlan.' + this.teacherLessonPlan.id)
                        .listen('.teacherLessonPlanDestroy', (e) => {
                            if(e.type==='logicItem'){
                                this.$delete(this.teacherLessonPlan.teacherLessonPlanModules, e.teacherLessonPlanModule_id)
                            }else if(e.type==='logicDetail'){
                                for(let i in this.teacherLessonPlan.teacherLessonPlanModules[e.teacherLessonPlanModule_id].teacherModuleDetails){
                                    if(this.teacherLessonPlan.teacherLessonPlanModules[e.teacherLessonPlanModule_id].teacherModuleDetails[i].id===parseInt(e.teacherModuleDetail_id)){
                                        this.teacherLessonPlan.teacherLessonPlanModules[e.teacherLessonPlanModule_id].teacherModuleDetails.splice(i, 1)
                                    }
                                }
                            }
                        })
                        .listen('.teacherLessonPlanModuleStore', (e) => {
                            this.$set(this.teacherLessonPlan.teacherLessonPlanModules, e.teacherLessonPlanModule.id, e.teacherLessonPlanModule);
                        })
                        .listen('.teacherLessonPlanStore', (e) => {
                            this.teacherLessonPlan=e.teacherLessonPlan;
                        })
                        .listen('.teacherModuleDetailStore', (e) => {
                            this.teacherLessonPlan.teacherLessonPlanModules[e.teacherLessonPlanModule_id].teacherModuleDetails.push(e.teacherModuleDetail)
                        })
                        .listen('.teacherLessonPlanSortBy', (e) => {
                            this.teacherLessonPlan.teacherLessonPlanModules[e.teacherLessonPlanModule_id].sortBy=e.sortBy;
                        });
                }
            },
            chooseLogic(chooseLogic_id, type) {
                if (type === 'logicItem') {
                    this.chooseLogic_id = chooseLogic_id;
                } else if (type === 'logicDetail') {
                    this.chooseLogicDetail_id = chooseLogic_id;
                }
            },
            chooseTeacherLogic(chooseTeacherLogic_id, type) {
                if (type === 'logicItem') {
                    this.teacherChooseLogic_id = chooseTeacherLogic_id;
                } else if (type === 'logicDetail') {
                    this.teacherChooseLogicDetail_id = chooseTeacherLogic_id;
                }
            },
            //标准逻辑框排序
            sortLogic(chooseLogic_id, sortType) {
                this.$axios.get(store.state.server + '/educationalAdministration/lessonPlan/sortLogic?lessonPlanModule_id=' + chooseLogic_id
                    + '&sortType=' + sortType
                    + '&' + localStorage.baseUrl).then(() => {
                })
            },
            //上课逻辑框排序
            teacherSortLogic(chooseLogic_id, sortType) {
                this.$axios.get(store.state.server + '/educationalAdministration/teacherLessonPlan/sortLogic?teacherLessonPlanModule_id=' + chooseLogic_id
                    + '&sortType=' + sortType
                    + '&' + localStorage.baseUrl).then(() => {
                })
            },
            //删除标准
            deleteLogic(logic_id, type) {
                this.$confirm('移除后将不可恢复，确定移除?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.button_loading = true;
                    this.$axios.delete(store.state.server + '/educationalAdministration/lessonPlan/' + logic_id + '?type=' + type + '&' + localStorage.baseUrl).then((response) => {
                        if (response.data.status == 'error') {
                            this.$message({
                                type: 'error',
                                message: response.data.msg
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            //删除上课
            deleteTeacherLogic(teacherLogic_id, type) {
                this.$confirm('移除后将不可恢复，确定移除?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.button_loading = true;
                    this.$axios.delete(store.state.server + '/educationalAdministration/teacherLessonPlan/' + teacherLogic_id + '?type=' + type + '&' + localStorage.baseUrl).then((response) => {
                        if (response.data.status == 'error') {
                            this.$message({
                                type: 'error',
                                message: response.data.msg
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleLogicalFrame() {
                this.loading = true;
                this.$axios.get(store.state.server + '/educationalAdministration/lessonPlan?classPlan_id=' + this.classPlan_id + '&' + localStorage.baseUrl).then((response) => {
                    if (response.data.status == 'success') {
                        this.lessonPlan = response.data.data.lessonPlan;
                        this.teacherLessonPlan = response.data.data.teacherLessonPlan;
                        this.loading = false;
                        if(this.lessonPlan){
                            this.handleEcho();
                        }
                    }
                })
            },
            //创建标准
            createLogicalFrame(type, content) {
                this.$axios.post(store.state.server + '/educationalAdministration/lessonPlan?classPlan_id=' + this.classPlan_id + '&type=' + type
                    + '&lessonPlanModule_id=' + this.chooseLogic_id
                    + '&content=' + content + '&'
                    + localStorage.baseUrl).then((response) => {
                    if (response.data.status == 'success') {
                        if(!this.lessonPlan){
                            this.handleLogicalFrame();
                        }
                    }
                })
            },
            handleAllSave() {
                this.$axios.get(store.state.server + '/educationalAdministration/lessonPlan/beforeSave?classPlan_id=' + this.lessonPlan.classPlan_id
                    + '&classPlan_ids=' + this.$parent.$parent.$parent.$parent.$parent.chosen.classPlan_id
                    + '&' + localStorage.baseUrl
                ).then((response) => {
                    if (response.status != '200') {
                        this.button_loading = false;
                    }
                    if (response.data.status == 'success') {
                        if (response.data.data.notice) {
                            this.$confirm(response.data.data.classNames + '已有教案，确认替换？', '提示', {
                                StartReturn: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.handleUpdate();
                                this.handleLogicalFrame();
                            }).catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: '已取消'
                                });
                            });
                        } else {
                            this.handleUpdate();
                            this.handleLogicalFrame();
                        }

                    }
                })
            },
            handleUpdate() {
                this.loading = true;
                this.$axios.put(store.state.server + '/educationalAdministration/lessonPlan/' + this.lessonPlan.id + '?' + localStorage.baseUrl, {
                        'lessonPlan': this.lessonPlan,
                        'classPlan_ids': this.$parent.$parent.$parent.$parent.$parent.chosen.classPlan_id
                    }
                ).then((response) => {
                    if (response.status != '200') {
                        this.loading = false;
                    }
                    if (response.data.status == 'success') {
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.loading = false;
                    }
                })
            },
            handleSingleUpdate() {
                this.loading = true;
                if(this.lessonPlan){
                    this.$axios.put(store.state.server + '/educationalAdministration/lessonPlan/' + this.lessonPlan.id + '?' + localStorage.baseUrl, {
                            'lessonPlan': this.lessonPlan,
                            'classPlan_ids': [this.lessonPlan.classPlan_id]
                        }
                    ).then((response) => {
                        if (response.status != '200') {
                            this.loading = false;
                        }
                        if (response.data.status == 'success') {
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.loading = false;
                        }
                    })
                }

            },
            handleTeacherAllSave() {
                this.$axios.get(store.state.server + '/educationalAdministration/teacherLessonPlan/beforeSave?classPlan_id=' + this.teacherLessonPlan.classPlan_id +
                    '&classPlan_ids=' + this.$parent.$parent.$parent.$parent.$parent.chosen.classPlan_id +
                    '&lessonPlan_id' + this.lessonPlan.id +
                    '&' + localStorage.baseUrl
                ).then((response) => {
                    if (response.status != '200') {
                        this.loading = false;
                    }
                    if (response.data.status == 'success') {
                        if (response.data.data.notice) {
                            this.$confirm(response.data.data.classNames + '已有教案，确认替换？', '提示', {
                                StartReturn: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.handleTeacherUpdate();
                            }).catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: '已取消'
                                });
                            });
                        } else {
                            this.handleTeacherUpdate();
                        }
                    }
                })
            },
            handleTeacherUpdate() {
                this.loading = true;
                if(this.teacherLessonPlan) {
                    this.$axios.put(store.state.server + '/educationalAdministration/teacherLessonPlan/' + this.teacherLessonPlan.id + '?' + localStorage.baseUrl, {
                            'teacherLessonPlan': this.teacherLessonPlan,
                            'classPlan_ids': this.$parent.$parent.$parent.$parent.$parent.chosen.classPlan_id
                        }
                    ).then((response) => {
                        if (response.status != '200') {
                            this.loading = false;
                        }
                        if (response.data.status == 'success') {
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.loading = false;
                        }
                    })
                }
            },
            handleSingleTeacherUpdate() {
                this.loading = true;
                if(this.teacherLessonPlan){
                    this.$axios.put(store.state.server + '/educationalAdministration/teacherLessonPlan/' + this.teacherLessonPlan.id + '?' + localStorage.baseUrl, {
                            'teacherLessonPlan': this.teacherLessonPlan,
                            'classPlan_ids': [this.teacherLessonPlan.classPlan_id]
                        }
                    ).then((response) => {
                        if (response.status != '200') {
                            this.loading = false;
                        }
                        if (response.data.status == 'success') {
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.loading = false;
                        }
                    })
                }
            },
            handleMousedown(logicItem_id) {
                this.$emit('changeState', false);
                this.dropLogicItem_id = logicItem_id;
            },
            drop: function (evt) {
                if (this.powers.includes(133)) {
                    evt.preventDefault();
                    //创建上课教案
                    this.$axios.post(store.state.server + '/educationalAdministration/teacherLessonPlan?classPlan_id=' + this.classPlan_id
                        + '&lessonPlanModule_id=' + this.dropLogicItem_id
                        + '&lessonPlan_id=' + this.lessonPlan.id
                        + '&' + localStorage.baseUrl).then(() => {
                    })
                }
            },
            allowDropLogic: function (event) {
                event.preventDefault();
                return true;
            },

        }
    }
</script>
<style>
    .ueditor-active .edui-editor-toolbarbox {
        display: block !important;
    }

    .ueditor-unactive {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 2000;
    }

    .edui-editor-toolbarbox {
        display: none !important;
    }
</style>
<style scoped lang="scss">
    .layout {
        height: 800px;
        .leftPlan {
            float: left;
            width: 40px;
            height: 100%;
        }

        .rightPlan {
            margin-left: 40px
        }
    }

    .leftBar {
        ul {
            margin: 0;
            list-style-type: none;
            padding: 0;
            li {
                position: relative;
                list-style-type: none;
                font-size: 17px;
                text-align: center;
                font-weight: 100;
                margin-bottom: -30px;
                margin-right: -5px;
                color: #6a6a81;
                .cancel {
                    opacity: 0.4;
                    &:hover {
                        opacity: 0.8;
                    }
                }
                .active {
                    opacity: 1;
                }
                .img {
                    width: 100%;
                }
                .tag {
                    position: absolute;
                    left: 2px;
                    top: 3px;
                }
            }
        }
    }

    .totalPlan {
        height: 800px;
        display: flex;
        flex-direction: row;
        .left-flex {
            display: flex;
            flex: 1;
            flex-direction: column;
            height: 100%;
            margin-right: 10px;
            .firstLine {
                margin-top: 10px;
                margin-left: 10px;
                margin-right: -10px;
                width: 95%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .title {
                    width: 130px;
                    height: 40px;
                    font-size: 15px;
                }
            }
            .secondLine {
                margin-top: 10px;
                margin-left: 10px;
                margin-right: -10px;
                width: 95%;
                height: 60px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .title {
                    width: 100px;
                    height: 40px;
                    font-size: 15px;
                }
            }

            .planItem {
                margin: 20px;
                height: 100%;
                .logic-item-style {
                    border: 1px dashed #cdd4de;
                    min-height: 50px;
                    margin-bottom: 15px;
                    .deleteDetail {
                        position: absolute;
                        width: 16px;
                        height: 16px;
                        z-index: 1000;
                        right: -5px;
                        top: -10px;
                        border-radius: 8px;
                        background-color: #d06b6b;
                        color: white;
                    }
                    .upLogic {
                        position: absolute;
                        width: 16px;
                        height: 16px;
                        z-index: 1000;
                        left: -5px;
                        top: -10px;
                        border-radius: 8px;
                        background-color: #000000;
                        color: white;
                    }
                    .downLogic {
                        position: absolute;
                        width: 16px;
                        height: 16px;
                        z-index: 1000;
                        left: -5px;
                        bottom: -10px;
                        border-radius: 8px;
                        background-color: #000000;
                        color: white;
                    }
                    .logic-detail-style {
                        border: 1px dashed #cdd4de;
                        margin: 5px;
                        position: relative;
                        .deleteDetail {
                            position: absolute;
                            z-index: 1000;
                            width: 16px;
                            height: 16px;
                            right: -1px;
                            top: -5px;
                            border-radius: 8px;
                            background-color: #d06b6b;
                            color: white;
                        }
                    }
                }
            }
        }
        .right-flex {
            background-color: #ffffff;
            flex: 1;
            display: flex;
            height: 100%;
            .teacherPlanItem {
                margin: 20px;
                height: 100%;
                .teacher-logic-item-style {
                    border: 1px dashed #cdd4de;
                    min-height: 50px;
                    margin-bottom: 15px;
                    .teacher-deleteDetail {
                        position: absolute;
                        z-index: 1000;
                        width: 16px;
                        height: 16px;
                        right: -5px;
                        top: -10px;
                        border-radius: 8px;
                        background-color: #d06b6b;
                        color: white;
                        text-align: center;
                    }
                    .teacher-upLogic {
                        position: absolute;
                        z-index: 1000;
                        width: 16px;
                        height: 16px;
                        left: -5px;
                        top: -10px;
                        border-radius: 8px;
                        background-color: #000000;
                        color: white;
                        text-align: center;
                    }
                    .teacher-downLogic {
                        position: absolute;
                        z-index: 1000;
                        width: 16px;
                        height: 16px;
                        left: -5px;
                        bottom: -10px;
                        border-radius: 8px;
                        background-color: #000000;
                        color: white;
                        text-align: center;
                    }
                    .teacher-logic-detail-style {
                        border: 1px dashed #cdd4de;
                        margin: 5px;
                        position: relative;
                        .teacher-deleteDetail {
                            position: absolute;
                            z-index: 1000;
                            width: 16px;
                            height: 16px;
                            right: -1px;
                            top: -5px;
                            border-radius: 8px;
                            background-color: #d06b6b;
                            color: white;
                            text-align: center;
                        }
                    }
                }
            }
        }
    }


</style>
